import { Placement } from 'react-joyride';
import { BaseTour } from '../types';

export class ActionDetailsTour extends BaseTour {
  id = 'action-details';

  content = 'Action Details Tour';

  placement: Placement = 'bottom';

  steps = {
    header: () => ({
      content: 'This is the Action Details page. Here you can see the Service Provider, Invoice Number, and current status of the invoice.',
      placement: 'bottom' as Placement,
    }),

    shipmentDropdown: () => ({
      content:
        'Use this dropdown to navigate between shipments. Shipments are grouped by status: Action Needed, Pending/Resolved, Under Review, and Processing.',
      placement: 'bottom' as Placement,
    }),

    tabsInvoiceShipmentLeg: () => ({
      content:
        'Switch between tabs to view invoice dates and totals, shipment weight and package info, or the multi-leg breakdown with ETD/ETA and linked invoices.',
      placement: 'bottom' as Placement,
    }),

    deviationsApprovalsTabs: () => ({
      content:
        'Switch between the Deviations tab and the Approvals tab. The Deviations tab shows all charge-level exceptions that need resolution. The Approvals tab shows decisions that have already been made and confirmed for this shipment.',
      placement: 'bottom' as Placement,
    }),

    deviationPills: () => ({
      content:
        'Each deviation is displayed as a pill showing the deviation type and count — Unit Price, Quantity, Unknown Charge, or Double Charge. Click a pill to filter the charge table to only that deviation type.',
      placement: 'bottom' as Placement,
    }),

    chargeDeviationsTable: () => ({
      content:
        'Review the detailed charge deviations here. Each row shows the charge name, invoiced vs. rate card values, deviation amount, and the assigned role responsible for resolution.',
      placement: 'bottom' as Placement,
    }),

    deviationQuestionnaire: () => ({
      content:
        'Click on a deviation row to open its questionnaire. This is where you make your decision — accept or reject with a required justification. The available options depend on your role and workflow. For example: One-Off, Recurring, Add Mapping, or Reject for unknown charges; Accept or Reject for unit price and quantity deviations.',
      placement: 'bottom' as Placement,
    }),

    toolbarIcons: () => ({
      content:
        'Access additional actions: download the Invoice Report, view invoice files (with Duplicate badge if relevant), open the configured Rate Card, check the Activity Log, attach documents, or Contact Freya to escalate an issue to the support team.',
      placement: 'left' as Placement,
    }),
  } as const;
}
